import { Card, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import React from 'react';

import {
    sustainabilityDefinition,
    sustainabilityPillars,
} from '@/features/about/definition/definitionData';
import './SustainabilityPillarsPreview.css';

/**
 * Compact preview of the About page's three sustainability pillars
 * (Environment, Economy, Society). Reuses the same names, descriptions, and
 * images as Definition.jsx so the two pages never fall out of sync.
 */
export default function SustainabilityPillarsPreview() {
    return (
        <section className="home-pillars-preview bg-light py-5">
            <Container>
                <h2 className="text-primary fw-bold text-center mb-3">
                    Built on Three Pillars
                </h2>
                <p className="lead text-info text-center mx-auto home-pillars-intro mb-5">
                    {sustainabilityDefinition}
                </p>
                <Row className="g-4 justify-content-center">
                    {sustainabilityPillars.map((pillar) => (
                        <Col key={pillar.id} xs={12} sm={6} md={4}>
                            <Card className="home-pillar-card h-100 text-center border-0 shadow-sm rounded-4 p-4">
                                <img
                                    src={pillar.imgSrc}
                                    alt=""
                                    className="home-pillar-icon mx-auto mb-3"
                                />
                                <Card.Title
                                    as="h3"
                                    className="fs-5 fw-bold text-primary"
                                >
                                    {pillar.title}
                                </Card.Title>
                                <Card.Text className="home-pillar-summary text-muted small mb-0">
                                    {pillar.description}
                                </Card.Text>
                            </Card>
                        </Col>
                    ))}
                </Row>
                <div className="text-center mt-5">
                    <Link
                        to="/about"
                        className="btn btn-outline-primary btn-lg"
                    >
                        Our Approach
                    </Link>
                </div>
            </Container>
        </section>
    );
}
